import React, { useCallback } from "react";
import CategoryManager from "../Common/CategoryManager";
import {
  deleteBlogCategory,
  getBlogCategories,
  saveBlogCategory,
} from "../../../store/actions/councilActions/blogAction";

/* Blog categories. The screen itself is shared with gallery categories. */
const BlogCategories = () => {
  const load = useCallback(() => getBlogCategories(false), []);

  return (
    <CategoryManager
      title="Blog Categories"
      countLabel="Blogs"
      countKey="blogs_count"
      load={load}
      save={saveBlogCategory}
      remove={deleteBlogCategory}
    />
  );
};

export default BlogCategories;
